import React from 'react';

const STORAGE_KEY = 'greentime.seenWelcome';

export const markWelcomeSeen = () => {
  try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* ignore */ }
};
export const hasSeenWelcome = () => {
  try { return !!localStorage.getItem(STORAGE_KEY); } catch { return false; }
};

export default function WelcomeModal({ onClose }) {
  const dismiss = () => { markWelcomeSeen(); onClose(); };

  return (
    <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && dismiss()}>
      <div className="modal" style={{ maxWidth: 520 }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 36, marginBottom: 4 }}>🏌️</div>
          <h2 style={{ fontSize: 22, marginBottom: 4 }}>Welcome to Greentime!</h2>
          <p style={{ fontSize: 13, color: '#7a7a6a', margin: 0 }}>
            Tee time coordination for people who play with multiple golf groups.
          </p>
        </div>

        <div style={{
          background: '#f4f1eb', borderRadius: 9, padding: '0.85rem 1rem', marginBottom: 14,
          fontSize: 13, color: '#4a4a3a', lineHeight: 1.55,
        }}>
          <p style={{ margin: 0 }}>
            <strong style={{ color: '#0d2b1a' }}>The problem:</strong> Juggling tee times across the
            Saturday crew, the work league, and your buddies' group chat gets messy. Texts get buried.
            Names get mixed up. You forget if you said yes.
          </p>
          <p style={{ margin: '0.6rem 0 0 0' }}>
            <strong style={{ color: '#0d2b1a' }}>The fix:</strong> One place to post tee times, see
            who's actually playing, and never wonder "wait, am I on this one?" again.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 18 }}>
          <FeatureRow
            emoji="🌐"
            title="Groups (and 'All Friends')"
            description="Organize your golfing buddies into groups — Saturday crew, work league, family, whatever. Post a tee time to one group, multiple groups, or share with everyone in your network via All Friends."
          />
          <FeatureRow
            emoji="📧"
            title="Email import"
            description={<>Got a confirmation email from your golf course? Forward it to <code style={{ background: '#f4f1eb', padding: '1px 5px', borderRadius: 4, fontSize: 12 }}>add@mail.greentime.app</code> and we'll auto-create the tee time. Date, course, phone, the works.</>}
          />
          <FeatureRow
            emoji="👀"
            title="See who's actually playing"
            description="Real-time visibility into who's joined, who's on the waitlist, and who's still on the fence. No more 'are we doing this or not?' group texts at 6am."
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button className="btn btn-accent" onClick={dismiss}>
            Got it, let's golf 🏌️
          </button>
        </div>

        <p style={{ textAlign: 'center', fontSize: 11, color: '#9a9a8a', marginTop: 12, marginBottom: 0 }}>
          You can revisit this anytime from the <strong>Help</strong> page.
        </p>
      </div>
    </div>
  );
}

const FeatureRow = ({ emoji, title, description }) => (
  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
    <div style={{ fontSize: 22, lineHeight: 1, flexShrink: 0, width: 28, textAlign: 'center' }}>{emoji}</div>
    <div>
      <div style={{ fontWeight: 500, fontSize: 14, color: '#0d2b1a', marginBottom: 2 }}>{title}</div>
      <div style={{ fontSize: 12, color: '#5a5a4a', lineHeight: 1.5 }}>{description}</div>
    </div>
  </div>
);
